(function ($) {
    $(document).ready(function () {

        // Run the peek on load
        calcCardPeek();

        // Run the peek on window resize
        $(window).on('resize', function(){
            calcCardPeek();
        });

        function calcCardPeek() {

            // For each hover column
            $.each($('.hover-column'), function () {

                // Get the elements
                let cardContentBackground = $('.card-content-background', this);
                let cardTitle = $('.card-title', this)

                // Get the height values - title height and padding
                let cardTitleHeight = parseInt(cardTitle.height());
                let cardTitlePaddingTop = parseInt(cardTitle.css('padding-top'));
                let cardTitlePaddingBottom = parseInt(cardTitle.css('padding-bottom'));

                // Add them up and prepare the style attribute
                let cardContentTopValue = cardTitleHeight + cardTitlePaddingTop + cardTitlePaddingBottom;
                let cardContentTopStyle = 'calc(100% - ' + cardContentTopValue + 'px)';

                // Apply the distance the card title peeks out the bottom of the image
                cardContentBackground.css('top', cardContentTopStyle);
            });
        }

    });
})(jQuery);